function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 161.335 161.335",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 151.411,
    height: 151.411,
    x: 87.988,
    y: 69.702,
    ry: 12.603,
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#009de6",
      strokeWidth: 9.924,
      strokeLinecap: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(-83.026 -64.74)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxOff);
export default __webpack_public_path__ + "static/media/checkbox-off.d9d09f9c238255b2c52fb49578e82f83.svg";
export { ForwardRef as ReactComponent };